module.exports = {
	"_args": [
		[
			{
				"raw": "ipfs@^0.24.1",
				"scope": null,
				"escapedName": "ipfs",
				"name": "ipfs",
				"rawSpec": "^0.24.1",
				"spec": ">=0.24.1 <0.25.0",
				"type": "range"
			},
			"/Users/pedroteixeira/projects/ipfs/ipfs-iiif-db"
		]
	],
	"_from": "ipfs@>=0.24.1 <0.25.0",
	"_id": "ipfs@0.24.1",
	"_inCache": true,
	"_location": "/ipfs",
	"_nodeVersion": "7.10.0",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/ipfs-0.24.1.tgz_1496051995770_0.4297193253878504"
	},
	"_npmUser": {
		"name": "daviddias",
		"email": "daviddias.p@gmail.com"
	},
	"_npmVersion": "5.0.0",
	"_phantomChildren": {},
	"_requested": {
		"raw": "ipfs@^0.24.1",
		"scope": null,
		"escapedName": "ipfs",
		"name": "ipfs",
		"rawSpec": "^0.24.1",
		"spec": ">=0.24.1 <0.25.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/ipfs/-/ipfs-0.24.1.tgz",
	"_shasum": "c91a89d0e051691c6d18824e577d72f6ada74aaa",
	"_shrinkwrap": null,
	"_spec": "ipfs@^0.24.1",
	"_where": "/Users/pedroteixeira/projects/ipfs/ipfs-iiif-db",
	"author": {
		"name": "David Dias",
		"email": "daviddias@ipfs.io"
	},
	"bin": {
		"jsipfs": "src/cli/bin.js"
	},
	"browser": {
		"libp2p-ipfs-nodejs": "libp2p-ipfs-browser",
		"./src/core/default-repo.js": "./src/core/default-repo-browser.js",
		"./src/core/components/init-assets.js": false,
		"./test/utils/create-repo-node.js": "./test/utils/create-repo-browser.js",
		"stream": "readable-stream"
	},
	"bugs": {
		"url": "https://github.com/ipfs/js-ipfs/issues"
	},
	"contributors": [
		{
			"name": "Andrew de Andrade",
			"email": "andrew@deandrade.com.br"
		},
		{
			"name": "CHEVALAY JOSSELIN",
			"email": "josselin54.chevalay@gmail.com"
		},
		{
			"name": "Caio Gondim",
			"email": "me@caiogondim.com"
		},
		{
			"name": "Christian Couder",
			"email": "chriscool@tuxfamily.org"
		},
		{
			"name": "Daniel J. O'Quinn",
			"email": "danieljoquinn@gmail.com"
		},
		{
			"name": "Daniela Borges Matos de Carvalho",
			"email": "alunassertiva@gmail.com"
		},
		{
			"name": "David Dias",
			"email": "daviddias.p@gmail.com"
		},
		{
			"name": "Enrico Marino",
			"email": "enrico.marino@email.com"
		},
		{
			"name": "Felix Yan",
			"email": "felixonmars@archlinux.org"
		},
		{
			"name": "Francisco Baio Dias",
			"email": "xicombd@gmail.com"
		},
		{
			"name": "Francisco Baio Dias",
			"email": "francisco@typeform.com"
		},
		{
			"name": "Friedel Ziegelmayer",
			"email": "dignifiedquire@gmail.com"
		},
		{
			"name": "Georgios Rassias",
			"email": "georassias@gmail.com"
		},
		{
			"name": "Greenkeeper",
			"email": "support@greenkeeper.io"
		},
		{
			"name": "Haad",
			"email": "haadcode@users.noreply.github.com"
		},
		{
			"name": "Harsh Vakharia",
			"email": "harshjv@users.noreply.github.com"
		},
		{
			"name": "João Antunes",
			"email": "j.goncalo.antunes@gmail.com"
		},
		{
			"name": "Lars Gierth",
			"email": "larsg@systemli.org"
		},
		{
			"name": "Marius Darila",
			"email": "marius.darila@gmail.com"
		},
		{
			"name": "Michelle Lee",
			"email": "michelle@protocol.ai"
		},
		{
			"name": "Mikeal Rogers",
			"email": "mikeal.rogers@gmail.com"
		},
		{
			"name": "Mithgol",
			"email": "getgit@mithgol.ru"
		},
		{
			"name": "Nuno Nogueira",
			"email": "nunofmn@gmail.com"
		},
		{
			"name": "Oskar Nyberg",
			"email": "oskar@oskarnyberg.com"
		},
		{
			"name": "Pau Ramon Revilla",
			"email": "masylum@gmail.com"
		},
		{
			"name": "Pedro Teixeira",
			"email": "i@pgte.me"
		},
		{
			"name": "Richard Littauer",
			"email": "richard.littauer@gmail.com"
		},
		{
			"name": "Rod Keys",
			"email": "rod@zokos.com"
		},
		{
			"name": "Sid Harder",
			"email": "sideharder@gmail.com"
		},
		{
			"name": "SidHarder",
			"email": "softwarenavigator@gmail.com"
		},
		{
			"name": "Stephen Whitmore",
			"email": "stephen.whitmore@gmail.com"
		},
		{
			"name": "Stephen Whitmore",
			"email": "noffle@users.noreply.github.com"
		},
		{
			"name": "Terence Pae",
			"email": "terencepae@gmail.com"
		},
		{
			"name": "Xiao Liang",
			"email": "yxliang01@users.noreply.github.com"
		},
		{
			"name": "haad",
			"email": "haad@headbanggames.com"
		},
		{
			"name": "jbenet",
			"email": "juan@benet.ai"
		},
		{
			"name": "kumavis",
			"email": "kumavis@users.noreply.github.com"
		},
		{
			"name": "nginnever",
			"email": "ginneversource@gmail.com"
		},
		{
			"name": "npmcdn-to-unpkg-bot",
			"email": "npmcdn-to-unpkg-bot@users.noreply.github.com"
		},
		{
			"name": "tcme",
			"email": "hi@this-connect.me"
		},
		{
			"name": "ᴠɪᴄᴛᴏʀ ʙᴊᴇʟᴋʜᴏʟᴍ",
			"email": "victorbjelkholm@gmail.com"
		}
	],
	"dependencies": {
		"async": "^2.4.1",
		"bl": "^1.2.1",
		"boom": "^5.1.0",
		"cids": "^0.5.0",
		"debug": "^2.6.8",
		"fsm-event": "^2.1.0",
		"glob": "^7.1.2",
		"hapi": "^16.1.1",
		"hapi-set-header": "^1.0.2",
		"hoek": "^4.1.1",
		"ipfs-api": "^14.0.2",
		"ipfs-bitswap": "~0.13.1",
		"ipfs-block": "~0.6.0",
		"ipfs-block-service": "~0.9.1",
		"ipfs-multipart": "~0.1.0",
		"ipfs-repo": "~0.13.1",
		"ipfs-unixfs": "~0.1.11",
		"ipfs-unixfs-engine": "~0.19.2",
		"ipld-resolver": "~0.11.1",
		"isstream": "^0.1.2",
		"joi": "^10.5.1",
		"libp2p-floodsub": "~0.9.4",
		"libp2p-ipfs-browser": "~0.24.1",
		"libp2p-ipfs-nodejs": "~0.25.2",
		"lodash.flatmap": "^4.5.0",
		"lodash.get": "^4.4.2",
		"lodash.has": "^4.5.2",
		"lodash.set": "^4.3.2",
		"lodash.sortby": "^4.7.0",
		"lodash.values": "^4.3.0",
		"mafmt": "^2.1.8",
		"mkdirp": "^0.5.1",
		"multiaddr": "^2.3.0",
		"multihashes": "~0.4.5",
		"once": "^1.4.0",
		"path-exists": "^3.0.0",
		"peer-book": "~0.4.0",
		"peer-id": "~0.8.7",
		"peer-info": "~0.9.2",
		"promisify-es6": "^1.0.2",
		"pull-file": "^1.0.0",
		"pull-paramap": "^1.2.2",
		"pull-pushable": "^2.1.1",
		"pull-sort": "^1.0.0",
		"pull-stream": "^3.6.0",
		"pull-stream-to-stream": "^1.3.4",
		"pull-zip": "^2.0.1",
		"read-pkg-up": "^2.0.0",
		"readable-stream": "1.1.14",
		"safe-buffer": "^5.0.1",
		"stream-to-pull-stream": "^1.7.2",
		"tar-stream": "^1.5.4",
		"temp": "^0.8.3",
		"through2": "^2.0.3",
		"update-notifier": "^2.1.0",
		"yargs": "8.0.1"
	},
	"description": "JavaScript implementation of the IPFS specification",
	"devDependencies": {
		"aegir": "^11.0.2",
		"buffer-loader": "0.0.1",
		"chai": "^4.0.0",
		"delay": "^2.0.0",
		"detect-node": "^2.0.3",
		"dir-compare": "^1.4.0",
		"dirty-chai": "^1.2.2",
		"eslint-plugin-react": "^7.0.1",
		"execa": "^0.6.3",
		"expose-loader": "^0.7.3",
		"form-data": "^2.1.4",
		"gulp": "^3.9.1",
		"interface-ipfs-core": "~0.28.0",
		"ipfsd-ctl": "~0.21.0",
		"left-pad": "^1.1.3",
		"lodash": "^4.17.4",
		"mocha": "^3.4.2",
		"ncp": "^2.0.0",
		"nexpect": "^0.5.0",
		"pre-commit": "^1.2.2",
		"pretty-bytes": "^4.0.2",
		"qs": "^6.4.0",
		"random-fs": "^1.0.3",
		"rimraf": "^2.6.1",
		"stream-to-promise": "^2.2.0",
		"transform-loader": "^0.2.4"
	},
	"directories": {},
	"dist": {
		"integrity": "sha512-a34atrZGOUyN4900j9UDd7XZjo+6fBumzEgxAbm6ZKYCmfqowTj0vSJ/9KGP64XfxHSCr6zDmwQHkuboIxEOGw==",
		"shasum": "c91a89d0e051691c6d18824e577d72f6ada74aaa",
		"tarball": "https://registry.npmjs.org/ipfs/-/ipfs-0.24.1.tgz"
	},
	"engines": {
		"node": ">=4.0.0",
		"npm": ">=3.0.0"
	},
	"gitHead": "e7560f0023a1d80a531601abb06238856a0f3886",
	"homepage": "https://github.com/ipfs/js-ipfs#readme",
	"keywords": [
		"IPFS"
	],
	"license": "MIT",
	"main": "src/core/index.js",
	"maintainers": [
		{
			"name": "daviddias",
			"email": "daviddias.p@gmail.com"
		},
		{
			"name": "jbenet",
			"email": "juan@benet.ai"
		}
	],
	"name": "ipfs",
	"optionalDependencies": {},
	"pre-commit": [
		"lint",
		"test"
	],
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/ipfs/js-ipfs.git"
	},
	"scripts": {
		"build": "gulp build",
		"coverage": "gulp coverage",
		"coverage-publish": "aegir-coverage publish",
		"lint": "aegir-lint",
		"release": "gulp release",
		"release-major": "gulp release --type major",
		"release-minor": "gulp release --type minor",
		"test": "gulp test --dom",
		"test:benchmark": "echo \"Error: no benchmarks yet\" && exit 1",
		"test:benchmark:browser": "echo \"Error: no benchmarks yet\" && exit 1",
		"test:benchmark:node": "echo \"Error: no benchmarks yet\" && exit 1",
		"test:benchmark:node:core": "echo \"Error: no benchmarks yet\" && exit 1",
		"test:benchmark:node:http": "echo \"Error: no benchmarks yet\" && exit 1",
		"test:browser": "npm run test:unit:browser",
		"test:interop": "npm run test:interop:node",
		"test:interop:browser": "mocha -t 60000 test/interop/browser.js",
		"test:interop:node": "mocha -t 60000 test/interop/node.js",
		"test:node": "npm run test:unit:node",
		"test:unit:browser": "gulp test:browser",
		"test:unit:node": "gulp test:node",
		"test:unit:node:cli": "TEST=cli npm run test:unit:node",
		"test:unit:node:core": "TEST=core npm run test:unit:node",
		"test:unit:node:http": "TEST=http npm run test:unit:node"
	},
	"version": "0.24.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/ipfs/package.json
// module id = 582
// module chunks = 0